import { URL_GET_MENU } from 'constants/urls';

/**
 * @type { Function }
 * @function getMenusApi - Fetch the menus data from the GetMenusApi() API End-Point.
 * @returns { Object[] } Return roleGroups, menus, and tabs arrays.
 */
const getMenusApi = async () => {
	const options = {
		method: 'GET',
		headers: { 'Content-Type': 'application/json;charset=UTF-8' },
	};

	const res = await fetch(URL_GET_MENU, options);

	if (!res.ok) {
		const message = `HTTP error! status message: ${res.statusText}`;
		throw new Error(message);
	} else {
		const data = await res.json();
		return data;
	}
};

export default getMenusApi;
